const FULL_NAME_HEADERS = new Set([
  "name",
  "student name",
  "pupil name",
  "full name",
]);
const FIRST_NAME_HEADERS = new Set([
  "first name",
  "firstname",
  "forename",
  "given name",
]);
const LAST_NAME_HEADERS = new Set([
  "last name",
  "lastname",
  "surname",
  "family name",
]);
const GENDER_HEADERS = new Set(["gender", "sex"]);
const DATE_OF_BIRTH_HEADERS = new Set([
  "date of birth",
  "dateofbirth",
  "dob",
  "birth date",
  "birthdate",
]);

const toDisplayText = (value) =>
  value === null || value === undefined ? "" : String(value).trim();

const normalizeHeader = (value) =>
  toDisplayText(value)
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

const cleanName = (value) =>
  toDisplayText(value)
    .replace(/<style[^>]*>.*?<\/style>/gis, "")
    .replace(/<script[^>]*>.*?<\/script>/gis, "")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();

const findHeaderIndex = (header, aliases) =>
  header.findIndex((value) => aliases.has(value));

const containsFunctionSentinel = (row) =>
  row.some((value) => normalizeHeader(value).includes("function"));

/**
 * Convert CSV/XLSX rows into the pupil objects accepted by the student API.
 * Demographic values remain optional free text and are not normalized.
 */
export function parseStudentImportRows(inputRows) {
  if (!Array.isArray(inputRows) || inputRows.length === 0) return [];

  const rows = inputRows.map((row) => (Array.isArray(row) ? row : [row]));
  let headerRowIndex = -1;
  let indexes = null;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
    const header = rows[rowIndex].map(normalizeHeader);
    const candidate = {
      fullName: findHeaderIndex(header, FULL_NAME_HEADERS),
      firstName: findHeaderIndex(header, FIRST_NAME_HEADERS),
      lastName: findHeaderIndex(header, LAST_NAME_HEADERS),
      gender: findHeaderIndex(header, GENDER_HEADERS),
      dateOfBirth: findHeaderIndex(header, DATE_OF_BIRTH_HEADERS),
    };

    if (
      candidate.fullName !== -1 ||
      candidate.firstName !== -1 ||
      candidate.lastName !== -1
    ) {
      headerRowIndex = rowIndex;
      indexes = candidate;
      break;
    }
  }

  const startIndex = headerRowIndex === -1 ? 0 : headerRowIndex + 1;
  const students = [];
  const seenNames = new Set();

  for (let rowIndex = startIndex; rowIndex < rows.length; rowIndex += 1) {
    const row = rows[rowIndex];
    if (containsFunctionSentinel(row)) break;

    let name;
    if (!indexes) {
      name = cleanName(row[0]);
    } else if (indexes.fullName !== -1) {
      name = cleanName(row[indexes.fullName]);
    } else {
      const firstName = cleanName(
        indexes.firstName === -1 ? "" : row[indexes.firstName],
      );
      const lastName = cleanName(
        indexes.lastName === -1 ? "" : row[indexes.lastName],
      );
      name = `${firstName} ${lastName}`.trim();
    }

    if (!name) continue;
    const nameKey = name.toLowerCase();
    if (seenNames.has(nameKey)) continue;
    seenNames.add(nameKey);

    const student = { name };
    if (indexes && indexes.gender !== -1) {
      const gender = toDisplayText(row[indexes.gender]);
      if (gender) student.gender = gender;
    }
    if (indexes && indexes.dateOfBirth !== -1) {
      const dateOfBirth = toDisplayText(row[indexes.dateOfBirth]);
      if (dateOfBirth) student.dateOfBirth = dateOfBirth;
    }
    students.push(student);
  }

  return students;
}
